import licitoLogo from '../assets/licito-logo.svg'
import licitoDevLogo from '../assets/licito.dev.jpeg'
import palhocaLogo from '../assets/palhocaLogo.svg'
import logoLogin from '../assets/logoLogin.svg'
import banner1 from '../assets/banner1.png'
import banner2 from '../assets/banner2.png'
import banner3 from '../assets/banner3.png'
import palhocaBanner from '../assets/palhocaBanner.jpg'
import FrontinLogo from '../assets/pauloDeFrontinLogo.svg'
import FrontinBanner from '../assets/pauloDeFrontinBanner.jpg'
import FinepLogo from '../assets/FinepLogoo.svg'
import FinepBanner from '../assets/FinepBanner.png'
import Pasta from '../assets/pasta.svg'
import PastaVerde from '../assets/PastaVerde.svg'
import proconBanner from '../assets/proconBanner.png'
import proconLogo from '../assets/proconLogo.svg'
import badesulBanner from '../assets/BadesulBanner.png'
import badesulLogo from '../assets/BadesulLogo.svg'
import treMtBanner from '../assets/Tre-mtBanner.png'
import treMtLogo from '../assets/Tre-mtLogo.svg'
import florianopolisBanner from '../assets/BannerFlorianopolis.png'
import florianopolisLogo from '../assets/LogoFlorianopolis.svg'
import palmasBanner from '../assets/BannerPalmas.png'
import palmasLogo from '../assets/LogoPalmas.svg'
import pcspBanner from '../assets/PCSPBANNER.png'
import pcspLogo from '../assets/PCSPLOGO.svg'
import creaLogo from '../assets/CreaLogo.svg'
import creaBanner from '../assets/CreaBanner.png'
import logoDPMT from '../assets/LogoDPMT.svg'
import bannerDPMT from '../assets/BannerDPMT.png'
import logoCINDERONDONIA from '../assets/LogoCINDERONDONIA.svg'
import bannerCINDERONDONIA from '../assets/BannerCINDERONDONIA.png'
import goiasFomentoLogo from '../assets/GoiasFomentoLogo.svg'
import goiasFomentoBanner from '../assets/GoiasFomentoBanner.png'
import portoBeloBanner from '../assets/portoBeloBanner.png'
import portoBeloLogo from '../assets/portoBeloLogo.svg'
import tijucasBanner from '../assets/tijucasBanner.png'
import tijucasLogo from '../assets/tijucasLogo.svg'
import jaraguaDoSulBanner from '../assets/jaraguaDoSulBanner.jpg'
import jaraguaDoSulLogo from '../assets/jaraguaDoSulLogo.svg'
import cbmRnBanner from '../assets/cbmRnBanner.jpg'
import cbmRnLogo from '../assets/cbmRnLogo.svg'
import corupaBanner from '../assets/corupaBanner.png'
import corupaLogo from '../assets/corupaLogo.png'
import smcspBanner from '../assets/smcspBanner.jpg'
import smcspLogo from '../assets/smcspLogo.svg'
import prodespBanner from '../assets/prodespBanner.jpg'
import prodespLogo from '../assets/prodespLogo.svg'
import creaPRBanner from '../assets/creaPRBanner.jpg'
import creaPRLogo from '../assets/creaPRLogo.svg'
import itajaiBanner from '../assets/itajaiBanner.jpg'
import itajaiLogo from '../assets/itajaiLogo.svg'
import sefazSpBanner from '../assets/sefazSpBanner.jpg'
import sefazSpLogo from '../assets/sefazSpLogo.svg'
import scparBanner from '../assets/scparBanner.jpg'
import scparLogo from '../assets/scparLogo.svg'
import emerjBanner from '../assets/emerjBanner.png'
import emerjLogo from '../assets/emerjLogo.svg'


export const LICITO_IMAGES = {
    logo: licitoLogo,
    logoLogin: logoLogin,
    pasta: Pasta,
    banners: [banner1, banner2, banner3],
}

const DEV_IMAGES = {
    ...LICITO_IMAGES,
    logo: licitoDevLogo,
}

const PALHOCA_IMAGES = {
    ...LICITO_IMAGES,
    logo: palhocaLogo,
    logoLogin: '',
    banners: [palhocaBanner],
}

const PAULODEFRONTIN_IMAGES = {
    ...LICITO_IMAGES,
    logo: FrontinLogo,
    logoLogin: '',
    banners: [FrontinBanner],
}

const FINEP_IMAGES = {
    ...LICITO_IMAGES,
    logo: FinepLogo,
    pasta: PastaVerde,
    logoLogin: FinepLogo,
    banners: [FinepBanner],
}

const PROCON_IMAGES = {
    ...LICITO_IMAGES,
    logo: proconLogo,
    logoLogin: '',
    banners: [proconBanner],
}

const BADESUL_IMAGES = {
    ...LICITO_IMAGES,
    logo: badesulLogo,
    logoLogin: '',
    banners: [badesulBanner],
}

const TRE_MT_IMAGES = {
    ...LICITO_IMAGES,
    logo: treMtLogo,
    logoLogin: '',
    banners: [treMtBanner],
}

const FLORIANOPOLIS_IMAGES = {
    ...LICITO_IMAGES,
    logo: florianopolisLogo,
    logoLogin: '',
    banners: [florianopolisBanner],
}

const PALMAS_IMAGES = {
    ...LICITO_IMAGES,
    logo: palmasLogo,
    logoLogin: '',
    banners: [palmasBanner],
}

const PCSP_IMAGES = {
    ...LICITO_IMAGES,
    logo: pcspLogo,
    logoLogin: '',
    banners: [pcspBanner],
}

const CREA_SC_IMAGES = {
    ...LICITO_IMAGES,
    logo: creaLogo,
    logoLogin: '',
    banners: [creaBanner],
}

const DPMT_IMAGES = {
    ...LICITO_IMAGES,
    logo: logoDPMT,
    logoLogin: '',
    banners: [bannerDPMT],
}

const CINDERONDONIA_IMAGES = {
    ...LICITO_IMAGES,
    logo: logoCINDERONDONIA,
    logoLogin: '',
    banners: [bannerCINDERONDONIA],
}

const GOIASFOMENTO_IMAGES = {
    ...LICITO_IMAGES,
    logo: goiasFomentoLogo,
    logoLogin: '',
    banners: [goiasFomentoBanner],
}

const PORTOBELO_IMAGES = {
    ...LICITO_IMAGES,
    logo: portoBeloLogo,
    logoLogin: '',
    banners: [portoBeloBanner],
}

const TIJUCAS_IMAGES = {
    ...LICITO_IMAGES,
    logo: tijucasLogo,
    logoLogin: '',
    banners: [tijucasBanner],
}

const JARAGUADOSUL_IMAGES = {
    ...LICITO_IMAGES,
    logo: jaraguaDoSulLogo,
    logoLogin: '',
    banners: [jaraguaDoSulBanner],
}

const CBM_RN_IMAGES = {
    ...LICITO_IMAGES,
    logo: cbmRnLogo,
    logoLogin: '',
    banners: [cbmRnBanner],
}

const CORUPA_IMAGES = {
    ...LICITO_IMAGES,
    logo: corupaLogo,
    logoLogin: '',
    banners: [corupaBanner],
}

const SMCSP_IMAGES = {
    ...LICITO_IMAGES,
    logo: smcspLogo,
    logoLogin: '',
    banners: [smcspBanner],
}

const PRODESP_IMAGES = {
    ...LICITO_IMAGES,
    logo: prodespLogo,
    logoLogin: '',
    banners: [prodespBanner],
}

const CREA_PR_IMAGES = {
    ...LICITO_IMAGES,
    logo: creaPRLogo,
    logoLogin: '',
    banners: [creaPRBanner],
}

const ITAJAI_IMAGES = {
    ...LICITO_IMAGES,
    logo: itajaiLogo,
    logoLogin: '',
    banners: [itajaiBanner],
}

const SEFAZ_SP_IMAGES = {
    ...LICITO_IMAGES,
    logo: sefazSpLogo,
    logoLogin: '',
    banners: [sefazSpBanner],
}

const SCPAR_IMAGES = {
    ...LICITO_IMAGES,
    logo: scparLogo,
    logoLogin: '',
    banners: [scparBanner],
}

const EMERJ_IMAGES = {
    ...LICITO_IMAGES,
    logo: emerjLogo,
    logoLogin: '',
    banners: [emerjBanner],
}

const SUBDOMAIN_THEMES: {[key: string]: typeof LICITO_IMAGES} = {
    dev: DEV_IMAGES,
    palhoca: PALHOCA_IMAGES,
    paulodefrontin: PAULODEFRONTIN_IMAGES,
    finep: FINEP_IMAGES,
    procon: PROCON_IMAGES,
    badesul: BADESUL_IMAGES,
    'tre-mt': TRE_MT_IMAGES,
    florianopolis: FLORIANOPOLIS_IMAGES,
    palmas: PALMAS_IMAGES,
    pcsp: PCSP_IMAGES,
    'crea-sc': CREA_SC_IMAGES,
    dpemt: DPMT_IMAGES,
    cinderondonia: CINDERONDONIA_IMAGES,
    goiasfomento: GOIASFOMENTO_IMAGES,
    portobelo: PORTOBELO_IMAGES,
    tijucas: TIJUCAS_IMAGES,
    jaraguadosul: JARAGUADOSUL_IMAGES,
    'cbm-rn': CBM_RN_IMAGES,
    corupa: CORUPA_IMAGES,
    'smculturasp': SMCSP_IMAGES,
    prodesp: PRODESP_IMAGES,
    'crea-pr': CREA_PR_IMAGES,
    itajai: ITAJAI_IMAGES,
    sefazsp: SEFAZ_SP_IMAGES,
    scpar: SCPAR_IMAGES,
    emerj: EMERJ_IMAGES,
}

function getSubdomain() {
    const parts = window.location.hostname.split('.')

    if (parts.length > 2) {
        return parts[0]
    }
    return null
}

export function getCurrentImages() {
    const subdomain = getSubdomain()
    if (subdomain && SUBDOMAIN_THEMES[subdomain]) {
        console.log(
            `Subdomínio detectado: ${subdomain}. Usando tema específico.`
        )
        return SUBDOMAIN_THEMES[subdomain]
    }
    console.log(
        'Nenhum subdomínio específico ou tema encontrado. Usando cores padrão.'
    )
    return LICITO_IMAGES
}
